import moment from "moment";

import { EventType } from "~/types/event/event.types";
import { FullFilterType } from "~/types/filter/filter.types";

const isBetweenDates = (
  event: EventType,
  dateFrom: moment.Moment | undefined,
  dateTo: moment.Moment | undefined
) => {
  if (!dateFrom && !dateTo) return true;
  const eventDateFrom = moment(event.dateFrom).isAfter(dateFrom);
  const eventDateTo = moment(event.dateFrom).isBefore(dateTo);
  return eventDateFrom && eventDateTo;
};

export const getFilteredEvents = (
  events: EventType[],
  fullFilter: FullFilterType
) => {
  return events.filter(
    (event) =>
      (fullFilter.locations.length === 0 ||
        fullFilter.locations.includes(event.location)) &&
      (fullFilter.tags.length === 0 ||
        fullFilter.tags
          .map(({ id }) => id)
          .some((id) => event.tags.map(({ id }) => id).includes(id))) &&
      (!fullFilter.dates ||
        isBetweenDates(
          event,
          moment(fullFilter.dates?.dateFrom),
          moment(fullFilter.dates?.dateTo)
        ))
  );
};
